import React from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import LoadingSpinnerComponent from './LoadingSpinner';
import { encryptBody } from '../../common/secureBody';
import { getApiBaseUrl } from '../../../src/common/constants';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Link } from '@uhg-abyss/web/ui/Link';


interface optInFormData {
   phoneNumber: string[];
  subName: string;
  email: string;
  affil: string;
  provGrpNm: string;
  isAcknowledged: boolean;
}

export const OptOut = () => {

  const [optInData, setOptInData] = React.useState<optInFormData>({
    phoneNumber: [],
    subName: '',
    email: '',
    affil: '',
    provGrpNm: '',
    isAcknowledged: false,
  });

   const [areaCodes, setAreaCodes] = React.useState<any[]>();
   const nonceRef = React.useRef<string>('');

    const loadAreaCodesAndNonce = React.useCallback(() => {
      return fetch('/api/robo-web-2f9c1/robo-area-codes')
        .then((res) => {return res.json()})
        .then((data) => {
          const areaCodesArray = Array.isArray(data.results) ? data.results : [];
          setAreaCodes(areaCodesArray);
          if (data && typeof data.nonce === 'string') nonceRef.current = data.nonce;
        })
        .catch((err) => {
          setAreaCodes([]);
        });
    }, []);

    React.useEffect(() => {
      loadAreaCodesAndNonce();
    }, [loadAreaCodesAndNonce]);
  const [recaptchaTicked, setRecaptchaTicked] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const [currentPhoneNumber, setCurrentPhoneNumber] = React.useState('');
  const [areaCodeError, setAreaCodeError] = React.useState('');
  const [checkError, setChkError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [isAddPhoneModalOpen, setIsAddPhoneModalOpen] = React.useState(false);
  const [modalPhoneNumber, setModalPhoneNumber] = React.useState('');
  const [modalError, setModalError] = React.useState('');
  const [tempPhoneNumbers, setTempPhoneNumbers] = React.useState<string[]>([]);
  const [duplicateWarning, setDuplicateWarning] = React.useState('');
  const [duplicatemsg, setDuplicateMsg] = React.useState('');
  const [successModalOpen, setSuccessModalOpen] = React.useState(false);
  const [failureModalOpen, setFailureModalOpen] = React.useState(false);
  const [phoneInputFields, setPhoneInputFields] = React.useState<{ id: number; value: string; error: string }[]>([]);

  const [captchaNum1, setCaptchaNum1] = React.useState(0);
  const [captchaNum2, setCaptchaNum2] = React.useState(0);
  const [captchaAnswer, setCaptchaAnswer] = React.useState('');
  const [captchaValid, setCaptchaValid] = React.useState(false);
  const [captchaError, setCaptchaError] = React.useState('');

  const generateCaptcha = React.useCallback(() => {
    const num1 = Math.floor(Math.random() * 900) + 100;
    const num2 = Math.floor(Math.random() * 90) + 10;
    setCaptchaNum1(num1);
    setCaptchaNum2(num2);
    setCaptchaAnswer('');
    setCaptchaValid(false);
    setCaptchaError('');
  }, []);

  React.useEffect(() => {
    generateCaptcha();
  }, [generateCaptcha]);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const email = e.target.value.toLocaleLowerCase();
    setOptInData({ ...optInData, email: email });

    if (email.trim() !== '' && !validateEmail(email)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const handleOpenModal = () => {
    setModalPhoneNumber('');
    setModalError('');

    if (optInData.phoneNumber.length > 0) {
      setTempPhoneNumbers([...optInData.phoneNumber]);
    } else {
      setTempPhoneNumbers([]);
    }

    setIsAddPhoneModalOpen(true);
  };

  const handleAddPhoneToTempList = () => {
    const digits = modalPhoneNumber.replace(/\D/g, '');

    if (digits.length !== 10) {
      setModalError('Please enter a valid 10-digit phone number');
      return;
    }

    // Check for area code validation
    if (digits.length >= 3) {
      const area = digits.substring(0, 3);
      if (areaCodes && areaCodes.length > 0 && !areaCodes.includes(area)) {
        setModalError('Invalid area code');
        return;
      }
    }

    // Check for duplicates
    const allNumbers = [
      ...phoneInputFields.map(f => {return f.value}),
      ...optInData.phoneNumber,
      currentPhoneNumber
    ];
    if (allNumbers.includes(modalPhoneNumber)) {
      setModalError('This number is already included.');
      return;
    }

    const newId = phoneInputFields.length > 0 ? Math.max(...phoneInputFields.map(f => {return f.id})) + 1 : 1;
    setPhoneInputFields([...phoneInputFields, { id: newId, value: modalPhoneNumber, error: '' }]);
    setModalPhoneNumber('');
    setModalError('');
    setDuplicateMsg('');
  };

  const handleRemovePhoneInputField = (id: number) => {
    setPhoneInputFields(phoneInputFields.filter(field => {return field.id !== id}));
  };

  const handlePhoneInputChange = (id: number, value: string) => {
    const digits = value.replace(/\D/g, '');
    let error = '';

    if (digits.length >= 3) {
      const area = digits.substring(0, 3);
      if (areaCodes && areaCodes.length > 0 && !areaCodes.includes(area)) {
        error = 'Invalid area code';
      }
    }

    if (digits.length === 10) {
      const allNumbers = [
        ...phoneInputFields.filter(f => {return f.id !== id}).map(f => {return f.value}),
        ...optInData.phoneNumber,
        currentPhoneNumber
      ];
      if (allNumbers.includes(value)) {
        error = 'This number is already included.';
      }
    }

    setPhoneInputFields(phoneInputFields.map(field =>
      {return field.id === id ? { ...field, value, error } : field}
    ));
  };
  const handleRemoveFromTempList = (index: number) => {
    const updatedTempList = tempPhoneNumbers.filter((_, i) => {return i !== index});
    setTempPhoneNumbers(updatedTempList);
  };

  const handleSaveAllPhoneNumbers = () => {
    const validPhones = phoneInputFields
      .filter(field => {return field.value.replace(/\D/g, '').length === 10 && !field.error})
      .map(field => {return field.value});

    setOptInData({
      ...optInData,
      phoneNumber: [...tempPhoneNumbers, ...validPhones]
    });

    setPhoneInputFields([]);
    setModalPhoneNumber('');
    setModalError('');
    setTempPhoneNumbers([]);
    setIsAddPhoneModalOpen(false);
  };

  const handleCloseModal = () => {


    setPhoneInputFields([]);
    setModalPhoneNumber('');
    setModalError('');
    setTempPhoneNumbers([]);
    setIsAddPhoneModalOpen(false);
  };

const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCaptchaAnswer(value);

    if (value.trim() === '') {
      setCaptchaValid(false);
      setCaptchaError('');
      return;
    }

    // Only allow numeric input
    if (!/^[0-9]+$/.test(value)) {
      setCaptchaValid(false);
      setCaptchaError('Please enter a valid number');
      return;
    }

    const userAnswer = parseInt(value, 10);
    const correctAnswer = captchaNum1 + captchaNum2;
    if (userAnswer === correctAnswer) {
      setCaptchaValid(true);
      setCaptchaError('Verification successful!');
    } else {
      setCaptchaValid(false);
      setCaptchaError('Wrong answer');
    }
  };

  return (
  <React.Fragment>
    <style>
      {`
        /* Tablet screens (768px - 1024px) */
        @media (max-width: 1024px) and (min-width: 769px) {
          .opt-in-container {
            margin: 20px !important;
          }

          .opt-in-main-col {
            flex: 0 0 100% !important;
            max-width: 100% !important;
          }

          .form-col-4 {
            flex: 0 0 50% !important;
            max-width: 50% !important;
          }

          .form-col-8 {
            flex: 0 0 100% !important;
            max-width: 100% !important;
          }
        }

        /* Mobile screens (481px - 768px) */
        @media (max-width: 768px) and (min-width: 481px) {
          .opt-in-container {
            margin: 15px !important;
          }

          .opt-in-main-col,
          .form-col-4,
          .form-col-8,
          .form-col-10,
          .form-col-11 {
            flex: 0 0 100% !important;
            max-width: 100% !important;
          }

          .opt-in-grid {
            margin-left: 0px !important;
          }
        }

        /* Extra small screens (< 480px) */
        @media (max-width: 480px) {
          .opt-in-container {
            margin: 10px !important;
          }

          .opt-in-main-col,
          .form-col-4,
          .form-col-8,
          .form-col-10,
          .form-col-11,
          .form-col-12 {
            flex: 0 0 100% !important;
            max-width: 100% !important;
            padding: 5px !important;
          }

          .opt-in-grid {
            margin-left: 0px !important;
            width: 100% !important;
          }

          .abyss-button {
            width: 100% !important;
          }

          .abyss-text-input input,
          .abyss-button,
          span, div {
            font-size: 14px !important;
          }

          .radio-group-row .abyss-radio-group {
            flex-direction: column !important;
          }
        }
      `}
    </style>
    <div className="opt-in-container" style={{ margin: '40px' }}>
      <Grid className="opt-in-grid" style={{ marginTop: '20px',marginLeft:'1px',width:'99%' }} >
        <Grid.Col span={8} className="opt-in-main-col">

          {/* <Grid>
            <Grid.Col span={12}>
              <h3>
                Telephone Consumer Protection Act (TCPA) opt-out form for health care
                providers
              </h3>
              <div
                style={{
                  marginTop: '20px',
                }}
              >
                Please complete the following form to opt out of receiving automated or
                artificial communications from UnitedHealthcare. Once
                completed, click Submit at the bottom of the form and your account will be updated to stop all future automated
                or artificial voice calls from UnitedHealthcare to the phone number(s) you identify below.
                You may continue to receive these types of calls while the updates take effect.
                You may still receive certain live-dialed communications that UnitedHealthcare is required to provide.
              </div>
            </Grid.Col>
          </Grid> */}


         <Grid>
            <Grid.Col span={8} className="form-col-10">
              <span style={{ fontWeight: 'bold' }}>
                Designate the number(s) at which you would not like to be contacted for automated or artificial voice calls<span style={{
                  color: 'red',fontSize:'20px'
                }}>*</span>
              </span>
            </Grid.Col>
          </Grid>

          <Grid >
            <Grid.Col span={4} className="form-col-4">
              <TextInput
                css={{
                  'abyss-text-input': {
                    marginTop: '-10px !important'
                  }
                }}
                label=""
                mask="phone"
                value={currentPhoneNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  setCurrentPhoneNumber(value);
                  const digits = value.replace(/\D/g, '');
                  if (digits.length >= 3) {
                    const area = digits.substring(0, 3);
                    if (areaCodes && areaCodes.length > 0 && !areaCodes.includes(area)) {
                      setAreaCodeError('Invalid area code. Please enter a valid area code.');

                    } else {
                      setAreaCodeError('');
                    }
                  } else {
                    setAreaCodeError('');
                  }
                }}
                autoComplete="tel-local"
                inputLeftElement={
                  <IconSymbol icon="phone" color="#7D7F81" size="18px" css={{
                    'abyss-icon': {
                      marginTop: '-10px'
                    }
                  }} />
                }
              />
              {areaCodeError && (
                <div style={{ color: 'red', fontSize: '13px', marginTop: '2px' }}>{areaCodeError}</div>
              )}
            </Grid.Col>
            <Grid.Col span={4}></Grid.Col>

          </Grid>

          <Grid >
            <Grid.Col span={8} className="form-col-8">
              {optInData.phoneNumber.length > 0 && (
                            <div style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '10px',
                              marginTop: '10px'
                            }}>
                              {optInData.phoneNumber.map((phoneNumber, index) => {return (
                                <Badge
                                  key={index}
                                  rounded
                                  variant="info"
                                  outline
                                  css={{
                                    'abyss-badge': {
                                      padding: '6px 10px !important',
                                      fontSize: '14px',
                                      display: 'inline-flex !important',
                                      alignItems: 'center !important',
                                      gap: '6px',
                                      lineHeight: '1 !important',
                                      height: 'auto !important'
                                    }
                                  }}
                                >
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    lineHeight: '1'
                                  }}>
                                    <IconSymbol icon="phone" size="16px" style={{ display: 'flex' }} />
                                    <span style={{ display: 'flex', alignItems: 'center' }}>{phoneNumber}</span>
                                    <IconSymbol
                                      icon="close"
                                      size="16px"
                                      style={{ display: 'flex', cursor: 'pointer' }}
                                      onClick={() => {
                                        const updatedPhoneNumbers = optInData.phoneNumber.filter((_, i) => {return i !== index});
                                        console.log('Removing phone number at index:', index);
                                        console.log('Updated array:', updatedPhoneNumbers);
                                        setOptInData({ ...optInData, phoneNumber: updatedPhoneNumbers });
                                      }}
                                    />
                                  </div>
                                </Badge>
                              )})}
                            </div>
                          )}
            </Grid.Col>
          </Grid>

          <Grid style={{marginTop: '-15px'}}>
            <Grid.Col span={8} className="form-col-8">
               <Button
                variant="outline"
                after={<IconSymbol icon="add_circle" />}
                onClick={handleOpenModal}
                isDisabled={currentPhoneNumber.replace(/\D/g, '').length !== 10 || areaCodeError !== ''}
              >
                Add phone number
              </Button>
            </Grid.Col>
            <Grid.Col span={4} ></Grid.Col>
          </Grid>

          <Grid style={{ marginBottom: '10px',  marginTop: '5px' }}>
            <Grid.Col span={4} className="form-col-4">
              <TextInput
                label="Submitter name"
                value={optInData.subName}
                onChange={(e) => {return setOptInData({ ...optInData, subName: e.target.value })}}
                inputLeftElement={
                  <IconSymbol icon="person" color="#7D7F81" size="18px" css={{
                    'abyss-icon': {
                      marginTop: '0px'
                    }
                  }} />
                }
              />
            </Grid.Col>
          <Grid.Col span={4} className="form-col-4">
                        <TextInput
                          label="Email Address"
                          value={optInData.email}
                          onChange={handleEmailChange}
                          inputLeftElement={
                            <IconSymbol icon="email" color="#7D7F81" size="18px" css={{
                              'abyss-icon': {
                                marginTop: '0px'
                              }
                            }} />
                          }
                        />
                        {emailError && (
                          <div style={{ color: 'red', fontSize: '13px', marginTop: '2px' }}>{emailError}</div>
                        )}
                      </Grid.Col>
          </Grid>

          <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={12} className="form-col-12 radio-group-row">
              <RadioGroup display="row" label="Affiliation" value={optInData.affil} onChange={(e) => {return setOptInData({ ...optInData, affil: e.target.value })}}>
                <RadioGroup.Radio label="Provider" value="Provider" />
                <RadioGroup.Radio label="Office staff" value="Office staff" />
                <RadioGroup.Radio label="Scheduling/billing" value="Scheduling/billing" />
                <RadioGroup.Radio label="Vendor" value="Vendor" />
                <RadioGroup.Radio label="Other" value="Other" />
              </RadioGroup>
            </Grid.Col>
          </Grid>

          <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={8} className="form-col-8">
              <TextInput
                label="Provider group name(s)"
                value={optInData.provGrpNm}
                onChange={(e) => {return setOptInData({ ...optInData, provGrpNm: e.target.value })}}
                inputLeftElement={
                  <IconSymbol icon="group" color="#7D7F81" size="18px" css={{
                    'abyss-icon': {
                      marginTop: '0px'
                    }
                  }} />
                }
              />
            </Grid.Col>
          </Grid>

             <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={8} className="form-col-8">
              <Checkbox
                css={{
                  'abyss-checkbox-label': {
                    fontWeight: 'bold'
                  }
                }}
                label={(<React.Fragment>I acknowledge that by clicking Submit, I request to stop receiving automated or artificial communications from UnitedHealthcare to the identified phone number(s).<span style={{ color: 'red',fontSize:"20px" }}>*</span></React.Fragment>) as any}
                isChecked={optInData.isAcknowledged}
                onChange={e => {return setOptInData({ ...optInData, isAcknowledged: e.target.checked })}}
              />
            </Grid.Col>
          </Grid>

        <Grid style={{ marginBottom: '10px' }}>
            <Grid.Col span={8} className="form-col-8">
              <div style={{
                padding: '20px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                border: '1px solid #e0e0e0',
                marginTop: '20px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  marginBottom: '10px'
                }}>
                  <IconSymbol icon="shield" color="#002677"  size="24px" />
                  <h6 style={{ fontWeight: 'bold', fontSize: '16px',color:'#323334' }}>
                    Verify you are human
                  </h6>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  marginBottom: '15px'
                }}>
                  <div style={{
                    padding: '8px',
                    backgroundColor: 'white',
                    color: '#323334',
                    borderRadius: '8px',
                    fontSize: '18px',
                    border:'1px solid #CBCCCD',
                    fontWeight: 'bold',
                    width: 'auto',
                    textAlign: 'center',
                    letterSpacing: '1px'
                  }}>
                    {captchaNum1} + {captchaNum2} = ?
                  </div>

                  <span
                    onClick={generateCaptcha}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '500',
                        color:'#196ecf',
                      textDecoration: 'none'
                    }}
                  >
                    <IconSymbol icon="refresh" />
                    Refresh
                  </span>
                </div>

                <div style={{ width: '250px' }}>
                  <label style={{
                    display: 'block',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                    color: '#323334'
                  }}>
                    Enter the answer
                  </label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '46%' }}>
                    <div
                      onClick={() => {
                        const currentVal = parseInt(captchaAnswer || '0', 10);
                        if (currentVal > 0) {
                          const newVal = (currentVal - 1).toString();
                          handleCaptchaChange({ target: { value: newVal } } as any);
                        }
                      }}
                      style={{
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        backgroundColor: '#002677',
                        transition: 'all 0.2s'
                      }}
                    >
                      <IconSymbol icon="remove" color="white" size="20px" />
                    </div>
                    <div style={{ position: 'relative', flex: 1 }}>
                      <input
                        // type="number"
                        value={captchaAnswer}
                        onChange={(e) => {
                          const val = e.target.value.replace(/[^0-9]/g, '');
                          handleCaptchaChange({ ...e, target: { ...e.target, value: val } });
                        }}
                        placeholder=""
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          fontSize: '14px',
                          border: captchaError && captchaError !== 'Verification successful!' ? '1px solid #c62828' : '1px solid #ccc',
                          borderRadius: '4px',
                          outline: 'none',
                          transition: 'border-color 0.2s',
                        }}
                        onFocus={(e) => {
                          if (!captchaError || captchaError === 'Verification successful!') {
                            e.target.style.borderColor = '#002677';
                          }
                        }}
                        onBlur={(e) => {
                          if (!captchaError || captchaError === 'Verification successful!') {
                            e.target.style.borderColor = '#ccc';
                          }
                        }}
                      />
                    </div>
                    <div
                      onClick={() => {
                        const currentVal = parseInt(captchaAnswer || '0', 10);
                        const newVal = (currentVal + 1).toString();
                        handleCaptchaChange({ target: { value: newVal } } as any);
                      }}
                      style={{
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        border: '1px solid #ccc',
                        borderRadius: '50%',
                        backgroundColor: '#002677',
                        transition: 'all 0.2s'
                      }}
                    >
                      <IconSymbol icon="add" color="white" size="20px" />
                    </div>
                  </div>

                </div>

                {captchaValid && (
                  <Alert
                  style={{
                    marginTop:'10px',
                    fontWeight:'bold'
                  }}
  title=""
  variant="success"
>
  Verification successful.
</Alert>

                )}
                {!captchaValid && captchaError === 'Wrong answer' && (

                  <Alert
                  style={{
                    marginTop:'10px'
                    ,fontWeight:'bold'
                  }}
  title=""
  variant="error"
>
  Incorrect answer. Please try again.
</Alert>
                )}
              </div>
            </Grid.Col>
          </Grid>



        </Grid.Col>
      </Grid>



      <Button
  style={{ marginTop: '20px',marginBottom:'10px',marginLeft:'10px' }}
  isDisabled={
    (optInData.phoneNumber.length === 0 && currentPhoneNumber.replace(/\D/g, '').length !== 10) ||
    !optInData.isAcknowledged
  || areaCodeError !== '' ||  !captchaValid
  }
  onClick={async() => {


    setLoader(true);
    if (optInData.email && !validateEmail(optInData.email)) {
      setErrorMessage('Please enter a valid email address before submitting.');
      setLoader(false);
      return;
    }

    let allPhoneNumbers = [...optInData.phoneNumber];

    if (currentPhoneNumber && currentPhoneNumber.replace(/\D/g, '').length === 10) {
      if (!allPhoneNumbers.includes(currentPhoneNumber)) {
        allPhoneNumbers.push(currentPhoneNumber);
      }
    }

    const formattedPhoneNumbers = allPhoneNumbers.map(phone => {return phone.replace(/\D/g, '')});

    const phoneNumbersString = formattedPhoneNumbers.join(', ');

    const submitPayload = {
      ...optInData,
      phoneNumbers: phoneNumbersString
    };

     try {
                const upsertPayload = {
                  applicationName: 'robo',
                  phoneNumber: phoneNumbersString,
                  action: 'upsert',
                  subName: optInData.subName,
                  consentType: 'O',
                  email: optInData.email,
                  provGrpNm: optInData.provGrpNm,
                  affil: optInData.affil
                };
                const securedBody = (await encryptBody(upsertPayload)) ?? upsertPayload;
                const response = await fetch('/api/robo-web-2f9c1/robo-upsert', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ ...securedBody, n: nonceRef.current })
                });
                // Refresh the single-use token for any subsequent submit.
                loadAreaCodesAndNonce();
                // if (!response.ok) {
                //   throw new Error('Network response was not ok');
                // }
                const data = await response.json();
                console.log('POST response status:', response);
                console.log('POST success:', data);
                if (
                  data &&
                  data.status &&
                  (data.status.code === 201 || data.status.code === 200) &&
                  (data.status.text === "Record updated successfully" || data.status.text==="Resource created successfully" || data.status.text === "Request completed successfully")
                ) {
 setLoader(false);
 setOptInData({
   phoneNumber: [],
   subName: '',
   email: '',
   affil: '',
   provGrpNm: '',
   isAcknowledged: false,
 });
 setCurrentPhoneNumber('');
 setCaptchaAnswer('');
 setCaptchaValid(false);
 setCaptchaError('');
 generateCaptcha();
 setSuccessModalOpen(true);
                }else {
                  setLoader(false);
                  if (data && data.status && data.status.code === 500) {
                  setFailureModalOpen(true);
                  } else {
                    setErrorMessage(
                      (data && data.status && data.status.text)
                        ? `Error: ${data.status.text}`
                        : 'Unknown error occurred. Please try again later.'
                    );
                  }
                }

              } catch (error) {
                setLoader(false);
                console.error('POST error:', error);
                setErrorMessage('POST error: ' + (error?.message || error));
              }

    console.log('Submit payload:', submitPayload);
    console.log('Payload JSON:', JSON.stringify(submitPayload, null, 2));

    // setSuccessModalOpen(true);
  }}
>
  Submit
</Button>

      <Modal
        isOpen={errorMessage !== ''}
        closeOnClickOutside={false}
        title="Alert !!!"
        model="closeOnClickOutside-modal"
        onClose={()=>{
          setErrorMessage('');
        }}
      >
        <Modal.Section style={{
          fontWeight: 'bold',
          fontSize:'16px'
        }}>{errorMessage}</Modal.Section>
        <Modal.Section>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => {return setErrorMessage('')}}>
              OK
            </Button>
          </div>
        </Modal.Section>
      </Modal>

      <Modal
        isOpen={duplicateWarning !== ''}
        closeOnClickOutside={false}
        title="Duplicate Phone Number"
        model="duplicate-warning-modal"
        onClose={() => {
          setDuplicateWarning('');
        }}
      >
        <Modal.Section style={{
          fontWeight: 'bold',
          fontSize: '16px'
        }}>
          {duplicateWarning}
        </Modal.Section>
        <Modal.Section>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => {return setDuplicateWarning('')}}>
              OK
            </Button>
          </div>
        </Modal.Section>
      </Modal>

      {/* <Modal
      css={{
        'abyss-modal-close-icon': {
          fontSize: '18px !important',
          color: '#002677 !important',
          fill: '#002677 !important',
        },
      }}
        isOpen={duplicatemsg !== ''}
        size={'$sm'}
        closeOnClickOutside={false}
        title=""
        onClose={() => {
          setDuplicateMsg('');
        }}
      >
        <Modal.Section style={{
          fontWeight: 'bold',
          fontSize: '16px',
          marginTop:'10px'
        }}>
          {duplicatemsg}
        </Modal.Section>
      </Modal> */}

      <Modal
        isOpen={successModalOpen}
        closeOnClickOutside={false}
        title=""
        size={'$lg'}
        model="success-modal"
        onClose={() => {
          setSuccessModalOpen(false);
        }}
      >
        <Modal.Section>
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center',padding:'16px' }}>
            <div style={{
              flexShrink: 0,
              backgroundColor: '#e8f5e9',
              borderRadius: '50%',
              padding: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <IconSymbol icon="check_circle" color="#4caf50" size="48px" />
            </div>
            <div style={{ flex: 1 ,marginTop:'20px'}}>
              <h5 style={{  fontWeight: 'bold',lineHeight: '1' ,marginBottom:'16px' }}>
                Thank you for registering your telephone number(s).
              </h5>
              <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.2' }}>
                Please allow 10 business days to be removed from the Opt Out registry. Once complete, you will no longer receive auto-dialer, artificial or pre-recorded calls.
              </p>
            </div>
          </div>
        </Modal.Section>

      </Modal>

       <Modal
              isOpen={failureModalOpen}
              closeOnClickOutside={false}
              title=""
              model="success-modal"
              onClose={() => {
                setFailureModalOpen(false);
              }}
            >
              <Modal.Section>
                <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                  <div style={{
                    flexShrink: 0,
                    backgroundColor: '#ffebee',
                    borderRadius: '50%',
                    padding: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <IconSymbol icon="error_outline" color="#c62828" size="48px" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ margin: '0 0 16px 0', fontSize: '24px', fontWeight: 'bold', lineHeight: '1.2' }}>
                      We could not process your request
                    </h3>
                    <p style={{ margin: 0, fontSize: '16px', lineHeight: '1.5'}}>
                      Something went wrong while submitting your request. Please try again later.
                    </p>
                  </div>
                </div>
              </Modal.Section>

            </Modal>


              <Modal
                  size={'$md'}
                    isOpen={isAddPhoneModalOpen}
                    closeOnClickOutside={false}
                    title=""
                    model="add-phone-modal"
                    onClose={handleCloseModal}
                    css={{
                      'abyss-modal-content': {
                        minWidth: '700px'
                      },
                      'abyss-modal-body':{
                        maxHeight:'20% !important'
                      }
                    }}
                  >
                    <Modal.Section>
                      <h5 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: 'bold' }}>Add additional phone numbers</h5>
                      <span style={{
                        marginBottom:'16px'
                      }}>Enter any additional phone numbers to opt out of automated or artificial outreach from UnitedHealthcare and its affiliates.</span>

                      <Grid style={{ marginTop: '10px' }}>

                        <Grid.Col span={11}>
                          <TextInput
                            label="Phone number"
                            mask="phone"
                            value={modalPhoneNumber}
                            autoComplete="tel-local"
                            onChange={(e) => {
                              const value = e.target.value;
                              setModalPhoneNumber(value);

                              const digits = value.replace(/\D/g, '');

                              // Clear error if less than 3 digits
                              if (digits.length < 3) {
                                setModalError('');
                                return;
                              }

                              // Check area code validation
                              if (digits.length >= 3) {
                                const area = digits.substring(0, 3);
                                if (areaCodes && areaCodes.length > 0 && !areaCodes.includes(area)) {
                                  setModalError('Invalid area code');
                                  return;
                                }
                              }

                              // Check for duplicates when 10 digits are entered
                              if (digits.length === 10) {
                                const allNumbers = [
                                  ...phoneInputFields.map(f => {return f.value}),
                                  ...optInData.phoneNumber,
                                  currentPhoneNumber
                                ];
                                if (allNumbers.includes(value)) {
                                  setModalError('This number is already included.');
                                  return;
                                }
                              }

                              // Clear error if all validations pass
                              setModalError('');
                            }}
                            inputLeftElement={
                              <IconSymbol icon="phone" color="#7D7F81" size="18px" css={{
                                'abyss-icon':{
                                  marginLeft:'6px'
                                }
                              }} />
                            }
                          />
                          {modalError && (
                            <div style={{ color: 'red', fontSize: '13px', marginTop: '2px' }}>{modalError}</div>
                          )}
                        </Grid.Col>
                        <Grid.Col span={1} css={{
                          'abyss-grid-col': {
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'center',
                            paddingBottom: modalError ? '38px' : '18px'
                          }
                        }}>
                          <IconSymbol
                            icon="add_circle"
                            color="#002677"
                            style={{
                              cursor: (modalPhoneNumber.replace(/\D/g, '').length === 10 && !modalError) ? 'pointer' : 'not-allowed',
                              opacity: (modalPhoneNumber.replace(/\D/g, '').length === 10 && !modalError) ? 1 : 0.5
                            }}
                            onClick={() => {
                              if (!modalError && modalPhoneNumber.replace(/\D/g, '').length === 10) {
                                handleAddPhoneToTempList();
                              }
                            }}
                          />
                        </Grid.Col>
                      </Grid>

                      <div style={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        marginTop: '30px',
                      }}>
                        {(phoneInputFields.length > 0 || tempPhoneNumbers.length > 0) && (
                          <span style={{
                            fontWeight:'bold',
                            color:'#002677'
                          }}>
                            Additional phone numbers
                          </span>
                        )}
                        {phoneInputFields.map((field) => {return (
                          <Grid key={field.id} >

                            <Grid.Col span={11}>
                              <TextInput
                              label=""
                                mask="phone"
                                value={field.value}
                                autoComplete="tel-local"
                                css={{
                                  'abyss-text-input':{
                                    // marginBottom:'2px !important',
                                    // marginLeft:'5px !important'
                                  }
                                }}
                                isDisabled={true}
                                inputLeftElement={
                                  <IconSymbol icon="phone" color="#7D7F81" size="18px" css={{
                                  'abyss-icon':{
                                    marginLeft:'6px',
                                    marginBottom:'6px'
                                  }}}/>
                                }
                              />
                              {field.error && (
                                <div style={{ color: 'red', fontSize: '13px', marginTop: '2px' }}>{field.error}</div>
                              )}
                            </Grid.Col>
                            <Grid.Col span={1} css={{
                              'abyss-grid-col': {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }
                            }}>
                              <IconSymbol
                                icon="delete"
                                size="24px"
                                style={{ cursor: 'pointer' }}
                                onClick={() => {return handleRemovePhoneInputField(field.id)}}
                              />
                            </Grid.Col>

                          </Grid>

                        )})}

                      {tempPhoneNumbers.length > 0 && (
                        <div>
                          <div>
                              {tempPhoneNumbers.map((phoneNumber, index) => {return (
                                <Grid key={index}>
                                  <Grid.Col span={11}>
                                    <TextInput
                                      label=""
                                      mask="phone"
                                      value={phoneNumber}
                                      css={{
                                        'abyss-text-input':{
                                          marginBottom:'2px !important',
                                          marginLeft:'5px !important'
                                        }
                                      }}
                                      isDisabled={true}
                                      inputLeftElement={
                                        <IconSymbol icon="phone" color="#7D7F81" size="18px" css={{
                                          'abyss-icon':{
                                            marginLeft:'6px',
                                            marginBottom:'6px'
                                          }
                                        }} />
                                      }
                                    />
                                  </Grid.Col>
                                  <Grid.Col span={1} css={{
                                    'abyss-grid-col': {
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }
                                  }}>
                                    <IconSymbol
                                      icon="delete"
                                      size="24px"
                                      // color='red'
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => {return handleRemoveFromTempList(index)}}
                                    />
                                  </Grid.Col>
                                </Grid>
                              )})}
                            </div>
                          </div>
                        )}
                      </div>

                      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop:'20px' }}>
                        <Button
                          variant="outline"
                          onClick={handleCloseModal}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={handleSaveAllPhoneNumbers}
                          // isDisabled={phoneInputFields.length === 0 || phoneInputFields.some(field => field.error)}
                        >
                          Save
                        </Button>
                      </div>
                    </Modal.Section>
                  </Modal>




       {
              loader && (
                <div
                  style={{
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 9999,
                  }}
                >
                  <LoadingSpinnerComponent isLoading={loader} msg={'Please wait.......'} />
                </div>
              )
            }
    </div>
  </React.Fragment>
  );
};
